import { useState } from "react";
import { Download } from "react-feather";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  ButtonDropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Spinner,
} from "reactstrap";

import JSZip from "jszip";
import {
  handleDownloadVideo,
  updateVideoPageState,
} from "../Pages/Video/VideoActions";
import {
  downloadAndPrepareVideos,
  getDirectory,
  getVideoUrls,
  getVideoUrlsById,
} from "../utilities";

const MultipleVideoDownloadDropdown = ({
  transcriptDownloadHandle,
  loadingTranscriptPdf,
}) => {
  const [videoDownloading, setVideoDownloading] = useState(false);
  const videos = useSelector((state) => state.videos);

  const [campaignDropdown, setCampaignDropdown] = useState(false);
  const [showTranscriptSubmenu, setShowTranscriptSubmenu] = useState(false);
  const [showVideoSubmenu, setShowVideoSubmenu] = useState(false);
  const downloadVideosCheckList = useSelector(
    (state) => state.videoPageStates.downloadVideosCheckList
  );
  const dispatch = useDispatch();

  const toggleDropdown = () => {
    setCampaignDropdown(!campaignDropdown);
    if (!campaignDropdown) {
      setShowTranscriptSubmenu(false);
      setShowVideoSubmenu(false);
    }
  };

  async function saveFile(directoryHandle, fileName, blob) {
    try {
      const fileHandle = await directoryHandle.getFileHandle(fileName, {
        create: true,
      });
      const writable = await fileHandle.createWritable();
      await writable.write(blob);
      await writable.close();
      // dispatch(
      //   updateVideoPageState({
      //     downloadVideoChecks: false,
      //     downloadVideosCheckList: [],
      //   })
      // );
    } catch (error) {
      console.error("Error in saving file:", error);
      alert(
        "Failed to save file. Please ensure you have permission to save in this location."
      );
    }
  }

  const handleDownloadVideos = async (
    getVideoUrlsFunc,
    additionalArgs = []
  ) => {
    const directoryHandle = await getDirectory();
    if (!directoryHandle) {
      setVideoDownloading(false);
      return;
    }

    // Invoke the passed function to get the video URLs
    const videoUrls = getVideoUrlsFunc(...additionalArgs);
    const zip = new JSZip();

    try {
      setVideoDownloading(true);
      const preparedZip = await downloadAndPrepareVideos(videoUrls, zip);
      const zipBlob = await preparedZip.generateAsync({ type: "blob" });
      await saveFile(directoryHandle, "Campaign videos.zip", zipBlob);
    } catch (error) {
      console.error("Error in downloading videos:", error);
      alert(`Error downloading videos: ${error.message}`);
    } finally {
      setVideoDownloading(false);
      dispatch(
        updateVideoPageState({
          downloadVideoChecks: false,
          downloadVideosCheckList: [],
        })
      );
    }
  };

  // To download all videos
  const handleDownloadAllVideos = () => {
    handleDownloadVideos(getVideoUrls, [videos]);
  };

  // To download selected videos based on a checklist
  const handleDownloadSelectedVideos = () => {
    handleDownloadVideos(getVideoUrlsById, [videos, downloadVideosCheckList]);
  };

  return (
    <>
      <ButtonDropdown
        className="download-list"
        isOpen={campaignDropdown}
        toggle={
          loadingTranscriptPdf || videoDownloading ? () => {} : toggleDropdown
        }
      >
        <DropdownToggle outline color="#000000" className="toogle-btn">
          <div className="download-btn-container ms-3">
            <div>
              {loadingTranscriptPdf || videoDownloading ? (
                <Spinner />
              ) : (
                <Download size={27} color="#783AD0" strokeWidth={1} />
              )}
            </div>

            <div className="title">
              {videoDownloading ? "Downloading" : "Download"}
            </div>
          </div>
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu">
          <DropdownItem
            onMouseEnter={() => {
              setShowTranscriptSubmenu(false), setShowVideoSubmenu(true);
            }}
          >
            Video
            <img
              height={9}
              src={require("@images/videos/expand-right-icon.png").default}
            />
          </DropdownItem>
          <DropdownItem divider />
          <DropdownItem
            onMouseEnter={() => {
              setShowTranscriptSubmenu(true), setShowVideoSubmenu(false);
            }}
          >
            Transcript
            <img
              height={9}
              src={require("@images/videos/expand-right-icon.png").default}
            />
          </DropdownItem>
        </DropdownMenu>

        <div className="download-list-sub-menu">
          {showTranscriptSubmenu && (
            <DropdownMenu className="dropdown-menu">
              <DropdownItem onClick={() => transcriptDownloadHandle("txt")}>
                txt
              </DropdownItem>
              <DropdownItem divider />
              <DropdownItem onClick={() => transcriptDownloadHandle("pdf")}>
                pdf
              </DropdownItem>
            </DropdownMenu>
          )}

          {showVideoSubmenu && (
            <DropdownMenu className="dropdown-menu">
              <DropdownItem onClick={() => handleDownloadAllVideos()}>
                All Video
              </DropdownItem>
              <DropdownItem divider />
              <DropdownItem
                onClick={() => {
                  dispatch(
                    updateVideoPageState({
                      downloadVideoChecks: true,
                      downloadVideosCheckList: [],
                    })
                  );
                }}
              >
                Select Video
              </DropdownItem>
            </DropdownMenu>
          )}
        </div>
      </ButtonDropdown>
      {downloadVideosCheckList.length > 0 && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ marginTop: "10px" }}
        >
          <div
            role="button"
            className="download-vid-button"
            onClick={() => {
              handleDownloadSelectedVideos();
            }}
          >
            <span className="label">Download video</span>
          </div>
          <div style={{ marginLeft: "3px" }}>
            <img
              src={require("@src/assets/images/vyrill/cross.png").default}
              alt=""
              role="button"
              width="20px"
              onClick={() => {
                dispatch(
                  updateVideoPageState({
                    downloadVideoChecks: false,
                    downloadVideosCheckList: [],
                  })
                );
              }}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default MultipleVideoDownloadDropdown;
